import { useAchievements } from "api/achievements";
import { useEvents } from "api/events";
import { useAppSelector } from "app/hooks";
import { Tooltip } from "components/Tooltips/Tooltip";
import { useFormikContext } from "formik";
import { useMessage } from "hooks/intl";
import { selectDefaultLanguageData } from "reduxState/translations/translationsSlice";
import { CampaignTriggers } from "types/campaigns";
import { useStyles } from "../styles";
import { getTriggerLabelBox } from "../utils";
import { internalEventsList } from "./InternalEvent/helpers";

export const TriggerBox = () => {
  const classes = useStyles();
  const { message } = useMessage();
  const defaultLang = useAppSelector(selectDefaultLanguageData);
  const { values } = useFormikContext<any>();
  const { event, trigger, achievementId } = values;
  const triggerDetails = getTriggerLabelBox(trigger);
  const { useAchievementData } = useAchievements();
  const { useCustomEventSchemaDetails } = useEvents();
  const { data: selectedAchievement } = useAchievementData(achievementId);
  const { data: selectedEvent } = useCustomEventSchemaDetails(
    trigger === CampaignTriggers.CUSTOM_EVENT && event,
  );

  const isTooltipVisible =
    trigger === CampaignTriggers.ACHIEVEMENT ||
    trigger === CampaignTriggers.CUSTOM_EVENT ||
    trigger === CampaignTriggers.INTERNAL_EVENT;

  const getTooltipLabel = () => {
    switch (trigger) {
      case CampaignTriggers.INTERNAL_EVENT:
        return `: ${message({
          id: internalEventsList.find(
            (eventDetails) => eventDetails.event === event,
          )?.name,
        })}`;
      case CampaignTriggers.ACHIEVEMENT:
        return `: ${selectedAchievement?.translations[defaultLang.code]?.name || ""}`;
      case CampaignTriggers.CUSTOM_EVENT:
        return `: ${selectedEvent?.name}`;
      default:
        return "";
    }
  };

  const tooltipLabel = `${message({ id: triggerDetails?.label })}${getTooltipLabel()}`;

  return (
    <Tooltip text={isTooltipVisible ? tooltipLabel : ""}>
      <div className={classes.triggerBox}>
        {triggerDetails?.icon}
        <span>{tooltipLabel}</span>
      </div>
    </Tooltip>
  );
};
